import { STATES } from 'common/domain/states';
import { MODALS } from 'common/domain/constants';

class LoansCatalogCardController {

  constructor($timeout, $state, $filter, $translate, LoansOperationsService) {
    'ngInject';
    this.state = $state;
    this.filter = $filter;
    this.translate = $translate;
    this.translations = {};
    this.timeout = $timeout;
    this.cannotSignUpError = undefined;
    this.loansOperationsService = LoansOperationsService;
  }

  $onInit() {
    this.loanDetails = this.loan.detail.basicCharacteristics;
    this._translate();
  }

  get modalCannotSignup() {
    return $(MODALS.CANNOT_SIGNUP);
  }

  goToDetails(loanId, canGoToDetail) {
    if (canGoToDetail) this.state.go(STATES.LOANS.DETAIL, { loanId });
  }

  _translate() {
    const TITLE = this.loan.title;
    const INTEREST_TYPE = this.loanDetails[2].title;
    const INTEREST_TYPE_VALUE = this.loanDetails[2].textToCatalog;
    const DEADLINE1 = this.loanDetails[1].title;
    const DEADLINE2 = this.loanDetails[1].desc;

    this.translate('GLOBALS.TO').then(translation => {
      this.translations.to = translation;
    });
    this.translate('GLOBALS.AND_TO').then(translation => {
      this.translations.andTo = translation;
    });
    this.translate(TITLE).then(translation => {
      this.translations.title = translation;
    });
    this.translate(INTEREST_TYPE).then(translation => {
      this.translations.interestType = translation;
    });
    this.translate(INTEREST_TYPE_VALUE).then(translation => {
      this.translations.interestTypeValue = translation;
    });
    this.translate(DEADLINE1).then(translation => {
      this.translations.deadline1 = translation;
    });
    this.translate(DEADLINE2).then(translation => {
      this.translations.deadline2 = translation;
    });
  }

  getTitle() {
    return this.translations.title;
  }

  getTextInterestType() {
    return `${this.translations.interestType}: ${this.translations.interestTypeValue}`;
  }

  getTextMaximumLimit() {
    return `${this.translations.deadline1}: ${this.translations.to}  ${this.translations.deadline2}`;
  }

  presentCannotSignUpModal(reason) {
    this.cannotSignUpError = reason;
    this.timeout(() => {
      this.modalCannotSignup.modal('show');
    });
  }

  goMyLoans() {
    this.modalCannotSignup.modal('hide');
    this.state.go(STATES.LOANS.MY_LOANS);
  }

  goToSignUp(loanId, hardReset) {
    if (this.serviceClosed) {
      return;
    }

    const from = STATES.LOANS.LOANS_CATALOG;
    const creditworthiness = this.creditworthiness;
    const creditworthinessOfLoan = creditworthiness[loanId];
    const hireDate = creditworthiness.hireDate;

    try {
      this.loansOperationsService.canSignUp(loanId, creditworthinessOfLoan, hireDate);
      return this.state.go(STATES.LOANS.SIGN_UP, {
        loanId,
        from,
        hardReset
      });
    } catch (reason) {
      this.presentCannotSignUpModal(reason.message);
    }
  }

  onSelectActionCard($event) {
    if ($event.actionInfo) {
      return this.goToDetails(this.loan.id, this.isMobileApp);
    }

    this.goToSignUp(this.loan.id, $event.hardReset);
  }

}

export default LoansCatalogCardController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalogCard/loansCatalogCard.controller.js